export interface SalaryChangePreview {
	userId: string;
	nif: string;
	email: string;
	name: string;
	surnames: string;
	currentSalary: number | null;
	newSalary: number | null;
	hasChange: boolean;
	rawValue?: string;
	needsReview?: boolean;
	extractedValue?: number;
}

export interface SalaryPreviewError {
	row: number;
	nif: string;
	message: string;
}

export interface SalaryPreviewResponse {
	changes: SalaryChangePreview[];
	totalUsers: number;
	changedCount: number;
	errors: SalaryPreviewError[];
}

const previewSalaryChanges = async (
	token: string,
	companyId: string,
	csvBase64: string
): Promise<SalaryPreviewResponse> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/users/salary-preview/${companyId}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify({ csvBase64 })
		}
	);

	if (!response.ok) {
		throw new Error('Failed to preview salary changes');
	}

	const json = await response.json();
	return json.data;
};

export default previewSalaryChanges;
